$(document).ready(function(){
    setTimeout(function(){
        var main_bnr = new Swiper(".product_detail_set .swiper-container", {
            speed:1000,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            spaceBetween: 0,
            pagination: {
                el: ".product_detail_set .swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            breakpoints: {
                990: {
                    spaceBetween: 0,
                },
            },
        });
    },1000);
});